import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

export const ReviewBlock = styled.div`
  border-radius: 16px;
  border: 1px solid rgba(var(--background-12-rgb), 0.05);
  background: var(--background-1);

  padding-block: 6px;
  padding-inline: 6px;
`

export const ReviewBlockLabel = styled(Typography).attrs({
  variant: 'body3-medium',
  component: 'div',
})`
  color: var(--text-12);
`
